import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Returns a handler that navigates back to the page the user came from
 * (passed as `state.from` when linking), falling back to `fallback`.
 */
export function useBackNavigation(fallback: string) {
    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state as { from?: string } | null)?.from;
    const isInternalPath = typeof from === 'string' && /^\/(?!\/)/.test(from);

    return useCallback(
        () => navigate(isInternalPath ? (from as string) : fallback),
        [navigate, from, isInternalPath, fallback]
    );
}
